import { Box } from '@mui/material';
import { useMemo } from 'react';

import { WorkflowProposalStatus } from '~/components/WorkflowProposalStatus';
import { ProposalProps, ProposalStatus } from '~/data/proposals';

import { useSxStyles } from './useStyles';

type PropsType = {
  status: ProposalStatus;
  proposals: ProposalProps[];
  showZero?: boolean;
};

export const EmployeeProposalsStatusCount = (props: PropsType) => {
  const { proposals, status, showZero } = props;
  const sxStyles = useSxStyles();

  const statusCount = useMemo(() => {
    return proposals.filter((p) => p.proposalStatus === status).length;
  }, [proposals, status]);

  return !!statusCount || (!statusCount && showZero) ? (
    <Box sx={sxStyles.root}>
      <WorkflowProposalStatus status={status}></WorkflowProposalStatus>
      <Box sx={sxStyles.counter}>{statusCount}</Box>
    </Box>
  ) : (
    <></>
  );
};
